import pokedex from "../assets/png/pokedex.png";
import caseih from "../assets/png/case.png";
import emprestimo from "../assets/png/emprestimo.png";
import tj from "../assets/png/tj.png";
import arado from "../assets/png/arado.png";
import horsch from "../assets/png/horsch.png";
import vista from "../assets/png/vista.png";
import vistaSite from "../assets/png/vista-site.png";

export const projectsData = [
  {
    id: 11,
    projectName: "Gestão Interna TratorCase",
    projectDesc:
      "Sistema interno de gestão de funcionários e máquinas da TratorCase, com backend altamente integrado ao aplicativo Flutter disponível na Play Store. Inclui controle de frota, telemetria, relatórios e dashboards operacionais.",
    tags: [
      "Next.js",
      "React",
      "Prisma",
      "AWS S3",
      "Node.js",
      "Express",
      "JWT",
      "React Query",
      "Chart.js",
      "TailwindCSS",
    ],
    code: "https://github.com/GoulartSazu",
    demo: "https://tratorcase.app.br/",
    image: caseih,
  },
  {
    id: 10,
    projectName: "Empréstimo Fácil",
    projectDesc:
      "Plataforma para simulação e contratação online de crédito rápido e descomplicado. Funciona como correspondente bancário para diversas modalidades: pessoal, consignado, FGTS, cartão e refinanciamento.",
    tags: [
      "Next.js",
      "React",
      "Swiper",
      "Framer Motion",
      "TailwindCSS",
      "React Icons",
    ],
    code: "https://github.com/GoulartSazu",
    demo: "https://emprestimosfacil.com.br/",
    image: emprestimo,
  },
  {
    id: 9,
    projectName: "Thiago José Pinheiro",
    projectDesc:
      "Site pessoal desenvolvido para o economista e contador Thiago José Pinheiro. Apresenta seu currículo acadêmico, certificações e especializações com foco em finanças, além de formulário de contato e design responsivo.",
    tags: [
      "React",
      "Material UI",
      "React Router",
      "AOS",
      "React Slick",
      "Excel Specialist",
    ],
    code: "https://github.com/GoulartSazu",
    demo: "https://tjpinheiro.com.br/",
    image: tj,
  },
  {
    id: 8,
    projectName: "Arado Máquinas Kuhn",
    projectDesc:
      "Site institucional da Arado Máquinas, referência em soluções agrícolas sustentáveis. O projeto inclui página de produtos, blog de notícias, vídeos, formulários de contato e banners personalizados para fortalecer a presença digital da empresa.",
    tags: [
      "Next.js",
      "React",
      "TailwindCSS",
      "Radix UI",
      "Lucide Icons",
      "Embla Carousel",
      "React Query",
    ],
    code: "https://github.com/GoulartSazu",
    demo: "https://aradomaquinaskuhn.com.br/",
    image: arado,
  },
  {
    id: 7,
    projectName: "Semear Horsch",
    projectDesc:
      "Site institucional da empresa Semear Máquinas Horsch, focado no setor agrícola. Traz informações sobre a empresa, seus produtos e soluções inovadoras, com foco em performance visual e responsividade.",
    tags: [
      "React",
      "Vite",
      "TailwindCSS",
      "Shadcn/UI",
      "Radix UI",
      "React Router",
      "Zod",
      "Lucide Icons",
    ],
    code: "https://github.com/GoulartSazu",
    demo: "https://semearhorsch.com.br/",
    image: horsch,
  },
  {
    id: 6,
    projectName: "Dashboard Vista Connect",
    projectDesc:
      "Sistema interno com login e painel gamificado para membros do Vista Uvaranas. Possui upload para AWS S3, autenticação JWT, pontuação por engajamento e ranking de participantes.",
    tags: [
      "React",
      "Node.js",
      "Express",
      "MySQL",
      "Sequelize",
      "AWS S3",
      "JWT",
      "Gamificação",
    ],
    code: "https://github.com/GoulartSazu",
    demo: "https://vistaconnect.com.br/dashboard/home",
    image: vista,
  },
  {
    id: 5,
    projectName: "Vista Connect",
    projectDesc:
      "O Vista Connect é um portal para moradores e empreendedores do condomínio Vista Uvaranas. O projeto promove o networking local, oferecendo uma vitrine de negócios, integração com WhatsApp e design moderno.",
    tags: [
      "React",
      "Vite",
      "TailwindCSS",
      "Shadcn/UI",
      "React Router",
      "Radix UI",
      "Lucide Icons",
    ],
    code: "https://github.com/GoulartSazu",
    demo: "https://vistaconnect.com.br/",
    image: vistaSite,
  },
  {
    id: 1,
    projectName: "SPLASH Estética Automotiva",
    projectDesc:
      "Esse é um sistema de agendamento de horário para lavagem de veículos, foi construído para atender a necessidade da empresa em possuir um controle de agendamentos, dashboard de faturamento e programa de fidelidade.",
    tags: ["React JS", "Node JS", "MySQL", "Javascript", "AWS"],
    code: "https://github.com/GoulartSazu",
    demo: "https://splashpg.com.br/",
    image:
      "https://www.tratorcase.com.br/wp-content/uploads/2024/08/splash-img.png",
  },
  {
    id: 2,
    projectName: "TratorCase",
    projectDesc:
      "Site criado para a empresa de TratorCase especializada em máquinas agrícolas. Foi desenvolvido um dashboard completo em WordPress, dessa maneira o cliente pode trocar qualquer imagem ou texto do site, pode adicionar ou remover produtos e editar as principais informações.",
    tags: ["HTML", "CSS", "Javascript", "WordPress", "PHP"],
    code: "https://github.com/GoulartSazu",
    demo: "https://www.tratorcase.com.br/index.html",
    image:
      "https://www.tratorcase.com.br/wp-content/uploads/2024/08/casetr.png",
  },
  {
    id: 3,
    projectName: "ALK Eventos",
    projectDesc:
      "ALK foi desenvolvido em 2022 enquanto estava na MAPA360, a empresa tem um diferencial de sites com layout modernos para todos seus clientes.",
    tags: ["HTML", "CSS", "Javascript", "WordPress", "PHP"],
    code: "https://mapa360.com.br/",
    demo: "https://www.alkeventos.com.br/",
    image: "https://www.tratorcase.com.br/wp-content/uploads/2024/08/alk.png",
  },
  {
    id: 4,
    projectName: "Pokedex",
    projectDesc:
      "A famosa pokedex que todo dev já deve ter feito na vida, esse projeto era um teste pra uma vaga de desenvolvedor frontend na empresa Losung. Deixei o repositório público no botão abaixo, hoje em dia tenho vontade de refatorar esse projeto pra servir de template para sistemas que tenham páginas de card.",
    tags: ["React JS", "Axios", "Styled Components", "Git"],
    code: "https://github.com/GoulartSazu/Teste-Losung/tree/main",
    demo: "https://www.linkedin.com/posts/matheus-goulart-de-freitas-08404219a_depois-de-realizar-um-projeto-teste-para-activity-6886734417918754817-MKCY?utm_source=share&utm_medium=member_desktop",
    image: pokedex,
  },
];

// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/
